module.exports = __webpack_public_path__ + "img/resumes_active.417dbb7a.svg";